import React, { Component } from 'react';

import { withIonLifeCycle } from '@ionic/react';

import PrescriptionTypeSelector from '../../components/PrescriptionRequest/PrescriptionTypeSelector';
import PrescriptionRequestForm from '../../components/PrescriptionRequest/PrescriptionRequestForm';

class PrescriptionRequestPage extends Component {
  render() {
    const { type } = this.props.match.params;

    if (type) {
      return (
        <PrescriptionRequestForm
          type={type}
          loader={this.props.loader}
          history={this.props.history}
          location={this.props.location}
          toast={this.props.toast}
        />
      );
    }

    return <PrescriptionTypeSelector history={this.props.history} />;
  }
}

export default withIonLifeCycle(PrescriptionRequestPage);
